import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { OrganizationRiderService } from '@uzurv/clara';
import { PaymentAccountModule } from '../payment-account/payment-account.module';
import { RequiresPermissionsModule } from '../directives/requires-permissions/requires-permissions.module';
import { TimezoneDateProvider } from '@uzurv/core';
import { PaymentAccountSelectorComponent } from './payment-account-selector.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatIconModule,
    MatSelectModule,
    MatTableModule,
    MatExpansionModule,
    PaymentAccountModule,
    ReactiveFormsModule,
    RequiresPermissionsModule
  ],
  exports: [PaymentAccountSelectorComponent],
  declarations: [PaymentAccountSelectorComponent],
  providers: [OrganizationRiderService, TimezoneDateProvider]
})
export class PaymentAccountSelectorModule {}
